var _line, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-camera-off",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 2,
    x2: 22,
    y1: 2,
    y2: 22
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 4h5L17 7h3a2 2 0 0 1 2 2v7.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.121 15.121A3 3 0 1 1 9.88 10.88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamOff);
export default __webpack_public_path__ + "static/media/camOff.f808eaa0400e3b55b169c53247209604.svg";
export { ForwardRef as ReactComponent };